import {md5} from '@wix/document-manager-utils'
import type {WmlExportFormat, WmlFile} from '@wix/document-services-types'

const stringifyWmlFile = ({content}: WmlFile): string => content

export const hashWml = ({structure, style, data, version}: WmlExportFormat): string => {
    const wmlString = version + stringifyWmlFile(structure) + stringifyWmlFile(data) + stringifyWmlFile(style)
    return md5(wmlString)
}
